const stringToBool = (str) => {
  if (str === 'true') {
    return true;
  }
  return false;
};
export const devToolsEnabled = typeof window !== 'undefined'
  ? stringToBool(window?.__EXPERIENCE_PROPS__?.expConfiguration?.['zustand-devtools:enable'])
  : false;